<span [innerHTML]="'NOTIFICATION_TEMPLATES.NORM_AGGREGATE'|translate:notification"></span>
